import styles from './Spinner.module.css';

function Spinner() {
  return <div className={styles.spinner} />;
}

export default Spinner;
